import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=d37a9a2a"
var script = {}
import style0 from "./Moderation.vue?vue&type=style&index=0&id=d37a9a2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports